import React, { useEffect } from 'react';
import queryString from 'query-string';
import { useQuery } from '@apollo/client';
import AuthenticationForm from './AuthenticationForm';
import { getActivationTokenData } from '../../queries/user';

const ConfirmInvite = ({ location, history }) => {
  const parsedQuery = queryString.parse(location.search);
  const { activationToken } = parsedQuery;

  const { data, loading, error } = useQuery(getActivationTokenData, {
    variables: { activationToken },
    pollInterval: 60 * 1000,
  });

  console.log({ data, loading, error });

  useEffect(() => {
    if (!loading && (!activationToken || error)) {
      const redirectTo = `/authentication/confirm?type=activationTokenNotFound`;
      history.push(redirectTo);
    }
  }, [activationToken, error, history, loading]);

  if (loading || !activationToken || error) {
    return null;
  }

  return <AuthenticationForm
    location={location}
    history={history}
    mandantSettings={data.getActivationTokenData?.selectedMandantSettings}
    agbLink={data.getActivationTokenData?.agbLink}
    mandantName={data.getActivationTokenData?.selectedMandant?.name}
    user={data.getActivationTokenData?.me}
  />;
};

export default ConfirmInvite;
